import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ModalTitleContainer')(
  css({
    display: 'flex',
    paddingLeft: ['default', 'xl', 'xl'],
    paddingRight: ['xxs', 'l', 'l'],
    paddingTop: 'm',
    paddingBottom: '0',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('ModalMessage')(
  css({
    px: ['default', 'xl', 'xl'],
    py: 'xs',
    mb: ['s', 'm', 'm'],
  }),
);

themeStyles.addBaseStyles('CloseButton')(
  css({
    zIndex: 'modal',
    bg: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    transform: 'translate3d(0,0,1px)',
  }),
);

export default themeStyles;
